exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2f4016f5] .el-card__body{height:100%}[data-v-2f4016f5] .el-icon-arrow-right{display:none}[data-v-2f4016f5] .el-badge__content{top:10px}", ""]);

// exports
